import React, { useEffect, useRef, useState } from "react";
/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

//Assets
import arrow_down from "../../assets/icons/arrow_down.svg";
import copy_icon from "../../assets/icons/copy_small.svg";
import { ReactComponent as CheckIcon } from "../../assets/check.svg";
import { ReactComponent as WalletIcon } from '../../assets/wallet_switch_icon.svg'

import { shortenAddress } from "../../utils/shortenAddress";
import colors from "../../constants/colors";
import { MOBILE } from "../../constants/breakpoints";
import { WarningText } from "../../shared/typography";
import { CustomTextbar } from "../../components/CustomTextbar";
import { Switch } from "../../components/Switch";

//Btns

const ExsistingIntialization = ({
  nftData,
  assetWallet,
  currentProxyMintInitInfo,
  selectedProxyTokenInitMint,
  setSelectedProxyTokenInitMint,
  setStartNewStorageWalletAddress,
  startNewStorageWalletAddress,
  nftMetadata,
  assetChain,
  isCurrentInitialization,
  activeItem,
  setActiveItem,
  startNew,
  setStartNew,
  isInitializingReq
}: {
  nftData: any;
  assetWallet: string;
  currentProxyMintInitInfo: any;
  selectedProxyTokenInitMint: any;
  setSelectedProxyTokenInitMint: any;
  setStartNewStorageWalletAddress: any;
  startNewStorageWalletAddress: string;
  nftMetadata: any;
  assetChain: any;
  isCurrentInitialization?: boolean
  activeItem: any;
  setActiveItem: any;
  startNew: boolean;
  setStartNew: Function;
  isInitializingReq: boolean
}) => {
  return (
    <section
      css={css`
          display: flex;
          margin-top: 40px;
          border: 1px solid #ccc4b3;
          border-radius: 12px;
          padding: 32px;
          flex-direction: column;
          gap: 15px;
          @media (max-width: ${MOBILE}px) {
            width: 100%;
            padding: 24px 16px;
          }
        `}
    >
      <div
        css={css`
            display: flex;
            flex-direction: column;
            gap: 24px;
          `}
      >
        <CustomTextbar
          config={{
            title: 'Contract Address',
            display: shortenAddress(nftMetadata.token_address),
            value: nftMetadata.token_address,
          }}
        />
        <CustomTextbar
          config={{
            title: 'Token ID',
            value: nftMetadata.token_id,
          }}
        />
        <CustomTextbar
          config={{
            title: 'Token Standard',
            value: 'ERC-721',
          }}
          isHideCopy
        />
        <CustomTextbar
          config={{
            title: 'Blockchain',
            value: assetChain,
          }}
          isHideCopy
        />
      </div>
      <span
        css={css`
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: auto;

            @media (max-width: ${MOBILE}px) {
              margin-top: 50px;
            }
          `}
      >
        <p
          css={css`
              color: #757272;
              font-weight: 500;
            `}
        >
          {isCurrentInitialization ? 'Intialized Wallet' : 'Previous Intialized Wallets'}
        </p>
        <span
          css={css`
              display: flex;
              width: 32px;
              height: 32px;
              background: #f98585;
              border-radius: 8px;
              align-items: center;
              justify-content: center;
              color: black;
              font-weight: 600;
            `}
        >
          ?
        </span>
      </span>
      <WalletPairDropDown
        proxyTokenInitPairInfo={currentProxyMintInitInfo}
        selectedProxyTokenInitMint={selectedProxyTokenInitMint}
        setSelectedProxyTokenInitMint={setSelectedProxyTokenInitMint}
        setStartNewStorageWalletAddress={setStartNewStorageWalletAddress}
        startNewStorageWalletAddress={startNewStorageWalletAddress}
        activeItem={activeItem}
        setActiveItem={setActiveItem}
        startNew={startNew}
        setStartNew={setStartNew}
        isInitializingReq={isInitializingReq}
      />
      {isCurrentInitialization
        ? <></>
        : <WarningText margin="0" padding='0 32px'>Looks Like you have already Initilized Proxy Mint for This Nft and Asset Wallet.</WarningText>
      }
    </section>
  );
};

const InfoTag = ({
  label,
  copy,
  value,
}: {
  label: string;
  copy?: boolean;
  value: string;
}) => {
  const [isCopying, setIsCopying] = useState(false)

  return (
    <span
      css={css`
        display: flex;
        width: 100%;
        justify-content: space-between;
        align-items: center;
      `}
    >
      <p
        css={css`
          font-weight: 500;
          font-size: 16px;
          color: #757272;
          margin: 0;
          margin-right: auto;
          width: max-content;

          @media (max-width: ${MOBILE}px) {
            font-size: 14px;
          }
        `}
      >
        {label}
      </p>
      <span
        css={css`
          display: flex;
          flex-grow: 1;
          border: 1px dashed #a29b8b84;
          margin: 0 8px;
          margin-top: auto;
          margin-bottom: 5px;
        `}
      ></span>
      <h1
        css={css`
          font-weight: 500;
          font-size: 16px;
          color: #191414;
          margin: 0;
          margin-left: auto;

          @media (max-width: ${MOBILE}px) {
            font-size: 14px;
          }
        `}
      >
        {shortenAddress(value ? value : "")}
      </h1>

      {copy ? (
        isCopying ?
          <CheckIcon
            css={css`
              margin-left: 5px;
              circle{
                fill: #96da96;
              }
              path{
                fill: #036403;
              }
            `}
          />
          : <img
            onClick={() => {
              navigator.clipboard.writeText(value);
              setIsCopying(true)
              setTimeout(() => {
                setIsCopying(false)
              }, 600);
            }}
            css={css`
            margin-left: 5px;
            cursor: pointer;
            &:hover {
              margin-left: 10px;
              transform: scale(1.2);
              transition: all 0.2s ease-in-out;
            }
          `}
            src={copy_icon}
            alt=""
          />
      ) : ''}
    </span>
  );
};

let Element = ({
  arrow,
  bottomBorder,
  initInfo,
  selectOption,
  toggleDropDown,
}: {
  arrow?: boolean;
  bottomBorder?: boolean;
  initInfo: any;
  selectOption?: any;
  toggleDropDown?: any;
}) => {
  return (
    <div
      css={css`
        display: flex;
        width: 454px;
        height: 84px;
        background: #ffffff;
        ${bottomBorder
          ? "border-bottom : 1px solid #CCC4B3;"
          : "border: 1px solid #CCC4B3;"}
        border-radius: ${bottomBorder ? "0" : "12px"};
        padding: 0 16px;
        align-items: center;

        @media (max-width: ${MOBILE}px) {
          width: 100%;
          height: 116px;
        }
      `}
      onClick={() => {
        if (arrow) {
          toggleDropDown();
          return;
        }
        selectOption(initInfo);
      }}
    >
      <div
        css={css`
          width: 75px;
          height: 75px;
          margin-right: 16px;
        `}
      >
        <WalletIcon />
      </div>
      <span
        css={css`
          display: flex;
          flex-direction: column;
          width: 100%;
          gap: 4px;

          @media (max-width: ${MOBILE}px) {
            display: none;
          }
        `}
      >
        <InfoTag
          label={"Asset Wallet Id"}
          value={initInfo.asset_owner_wallet_address}
        />
        <InfoTag
          label={"Storage Wallet Id"}
          value={initInfo.asset_storage_wallet_address}
        />
      </span>
      {/* Info tag mobile */}
      <div
        css={css`
          display: none;
          @media (max-width: ${MOBILE}px) {
            display: flex;
            flex-direction: column;
            row-gap: 4px;
          }
        `}
      >
        <MobileInfoTag
          label={"Asset Wallet Id"}
          value={initInfo.asset_owner_wallet_address}
        />
        <MobileInfoTag
          label={"Storage Wallet Id"}
          value={initInfo.asset_storage_wallet_address}
        />
      </div>
      {arrow && (
        <img
          css={css`
            margin-left: 27px;
            filter: brightness(-100%);
          `}
          src={arrow_down}
          alt=""
        />
      )}
    </div>
  );
};

const MobileInfoTag = ({
  label,

  value,
}: {
  label: string;

  value: string;
}) => {
  return (
    <span>
      <h1
        css={css`
          font-size: 14px;
          margin: 0;
          font-weight: 300;
          color: ${colors.INTERFACE_COLORS_DARK_STONE};
        `}
      >
        {label}
      </h1>
      <p
        css={css`
          font-size: 14px;
          margin: 0;
          font-weight: 500;
        `}
      >
        {shortenAddress(value ? value : "")}
      </p>
    </span>
  );
};

interface IItem {
  name: string
  title: string
}
const switchItems = [{ name: 'TYPE_1', title: 'Token Transfer' }, { name: 'TYPE_2', title: 'Signature Message (QR Code)' }]

const WalletPairDropDown = ({
  proxyTokenInitPairInfo,
  selectedProxyTokenInitMint,
  setSelectedProxyTokenInitMint,
  setStartNewStorageWalletAddress,
  startNewStorageWalletAddress,
  activeItem,
  setActiveItem,
  startNew,
  setStartNew,
  isInitializingReq
}: {
  proxyTokenInitPairInfo: any;
  selectedProxyTokenInitMint: any;
  setSelectedProxyTokenInitMint: any;
  setStartNewStorageWalletAddress?: any;
  startNewStorageWalletAddress?: string;
  activeItem: any;
  setActiveItem: any;
  startNew: boolean;
  setStartNew: Function;
  isInitializingReq: boolean
}) => {
  const [showDropDown, setShowDropDown] = useState(false);
  // const [storageWalletAddress, setStorageWalletAddress] = useState("");

  const elementRef = useRef<HTMLDivElement>(null);

  const selectOption = (proxyTokenInfo: any) => {
    setSelectedProxyTokenInitMint(proxyTokenInfo);
    setShowDropDown(false);
  };

  const toggleDropDown = () => {
    setShowDropDown(!showDropDown);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        elementRef.current &&
        !elementRef.current.contains(event.target as Node)
      ) {
        if (showDropDown) {
          setShowDropDown(false);
        }
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [toggleDropDown]);

  return (
    <div
      ref={elementRef}
      css={css`
        display: flex;
        position: relative;
        width: 454px;
        min-height: 84px;
        cursor: pointer;
        z-index: 100;

        @media (max-width: ${MOBILE}px) {
          width: 100%;
          height: max-content;
        }
      `}
    >
      {startNew ? (
        <div
          css={css`
            display: flex;
            width: 100%;
            flex-direction: column;
            gap: 10px;
          `}
        >
          {
            (proxyTokenInitPairInfo?.some((el: any) => el?.proxy_token_mint_method === "MESSAGE_SIGNATURE")
              ? <></>
              : <Switch toggle={(item: IItem) => { setActiveItem(item) }} items={switchItems} />)
          }

          {
            activeItem?.name === 'TYPE_1'
              ? <input
                placeholder="Enter your storage ID"
                css={css`
              width: 100%;
              height: 44px;
              background: #ffffff;
              border: 1px solid #ccc4b3;
              border-radius: 12px;
              padding: 12px 24px;
              font-weight: 400;
              font-size: 14px;
              color: ${colors.INTERFACE_COLORS_BASALT};
              /* margin-top: 20px; */
            `}
                type="text"
                value={startNewStorageWalletAddress}
                onChange={(e) => {
                  setStartNewStorageWalletAddress(e.target.value);
                }}
              /> : <></>
          }

          <span
            css={css`
              text-align: center;
              font-weight: 400;
              font-size: 14px;
              color: ${colors.INTERFACE_COLORS_BASALT};
              margin-top: 20px;
              text-transform: capitalize;
              &:hover {
                text-decoration: underline;
              }
            `}
            onClick={() => {
              setStartNew(false);
              setActiveItem({ name: 'TYPE_1', title: 'Token Transfer' });
              setStartNewStorageWalletAddress("");
            }}
          >
            select from previous initilizations
          </span>
          {/* add here */}
        </div>
      ) : (
        <div
          css={css`
            margin-top: 10px;
            width: 100%;
          `}
        >
          {/* Selected Pair */}
          <Element
            arrow
            initInfo={selectedProxyTokenInitMint}
            toggleDropDown={toggleDropDown}
          />

          {/* Dropdown */}
          <div
            id="pairDropDown"
            css={css`
              display: flex;
              flex-direction: column;
              width: 454px;
              height: max-content;
              background: #ffffff;
              border: 1px solid #ccc4b3;
              border-radius: 12px;
              overflow: hidden;
              margin-top: 4px;
              display: ${showDropDown ? "flex" : "none"};

              @media (max-width: ${MOBILE}px) {
                width: 100%;
              }
            `}
          >
            {proxyTokenInitPairInfo.map((pair: any) => {
              return (
                <Element
                  bottomBorder
                  initInfo={pair}
                  selectOption={selectOption}
                />
              );
            })}

            <span
              css={css`
                display: flex;
                width: 454px;
                height: 84px;
                align-items: center;
                justify-content: center;

                @media (max-width: ${MOBILE}px) {
                  width: 100%;
                }
              `}
            >
              <button
                css={css`
                  border: 1.5px solid #191414;
                  border-radius: 12px;
                  width: 414px;
                  height: 47.5px;
                  font-weight: 800;
                  font-size: 16px;
                  background-color: white;
                  cursor: pointer;

                  @media (max-width: ${MOBILE}px) {
                    width: 100%;
                  }
                `}
                onClick={() => {
                  selectOption({});
                  setStartNew(true);
                  toggleDropDown();
                }}
              >
                Start new
              </button>
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default ExsistingIntialization;
